module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-maker-d89e7f938b4f6cc76efd6098bb962e38.png";